import { AnexoFinanceiroIdentificador } from "@FN";

export function buildAnexoPrefix(id: AnexoFinanceiroIdentificador) {
    return `financeiro_${id.filial}${id.fornecedor}${id.loja}${id.cod}`;
}
  